import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { TopUpAddress, AddressService } from '@fgb/core';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';

import { TopUpAddressConfig, topUpAddressConfigDefault } from './top-up-address-config.model';
import { FGBValidators } from '@fgb/portal-component-library/src/lib/shared/validators';

@Component({
  selector: 'fgbcl-top-up-address',
  templateUrl: './top-up-address.component.html',
  styleUrls: ['./top-up-address.component.scss'],
})
export class TopUpAddressComponent implements OnInit {
  @Input() regex = RegexUS;
  @Input() topUpAddressConfig: TopUpAddressConfig = topUpAddressConfigDefault;
  @Output() submittedAddress = new EventEmitter<boolean>();

  public topUpAddressForm: UntypedFormGroup;
  submitted = false;

  constructor(private formBuilder: UntypedFormBuilder, private addressService: AddressService, private modalService: NgbModal) {}

  ngOnInit() {
    this.addressService
      .getTopUpAddress()
      .pipe(tap((address) => this.setupAddressForm(address)))
      .subscribe();
  }

  get f() {
    return this.topUpAddressForm.controls;
  }

  async save(address: TopUpAddress, isValid: boolean) {
    this.submitted = true;
    if (isValid) {
      await this.addressService.postTopUpAddress(address);
      this.submittedAddress.emit(true);
    }
  }

  cancel() {
    this.submittedAddress.emit(false);
    this.modalService.dismissAll();
  }

  setupAddressForm(topUpAddress: TopUpAddress) {
    this.topUpAddressForm = this.formBuilder.group({});
    if (this.topUpAddressConfig.showFirstName)
      this.topUpAddressForm.addControl('firstName', new UntypedFormControl(topUpAddress.FirstName, [Validators.required, FGBValidators.Empty]));
    if (this.topUpAddressConfig.showLastName)
      this.topUpAddressForm.addControl('surname', new UntypedFormControl(topUpAddress.Surname, [Validators.required, FGBValidators.Empty]));
    if (this.topUpAddressConfig.showAddressName)
      this.topUpAddressForm.addControl('addressName', new UntypedFormControl(topUpAddress.AddressName, [Validators.required, FGBValidators.Empty]));
    if (this.topUpAddressConfig.showStreet)
      this.topUpAddressForm.addControl('street', new UntypedFormControl(topUpAddress.Street, [Validators.required, FGBValidators.Empty]));
    if (this.topUpAddressConfig.showTown)
      this.topUpAddressForm.addControl('town', new UntypedFormControl(topUpAddress.Town, [Validators.required, FGBValidators.Empty]));
    if (this.topUpAddressConfig.showPostCode)
      this.topUpAddressForm.addControl(
        'postCode',
        new UntypedFormControl(topUpAddress.Postcode, [Validators.required, Validators.pattern(this.regex.postCode)])
      );
    if (this.topUpAddressConfig.showCountryRegion) {
      this.topUpAddressForm.addControl('Country', new UntypedFormControl(topUpAddress.Country, [Validators.required, FGBValidators.Empty]));
      this.topUpAddressForm.addControl('County', new UntypedFormControl(topUpAddress.County, [Validators.required, FGBValidators.Empty]));
    }
    if (this.topUpAddressConfig.showMobileNumber)
      this.topUpAddressForm.addControl(
        'homeNumber',
        new UntypedFormControl(topUpAddress.HomeNumber, [Validators.required, Validators.pattern(this.regex.number), FGBValidators.Empty])
      );
    if (this.topUpAddressConfig.showEmail)
      this.topUpAddressForm.addControl(
        'emailAddress',
        new UntypedFormControl(topUpAddress.EmailAddress, [Validators.required, Validators.pattern(this.regex.email), FGBValidators.Empty])
      );
  }
}
